<template>
    <a class="btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5 text-center"
       :href="linkToDocumentation"
       target="_blank">
        <i class="color-inherit p-0" :class="[icon]"/>
    </a>
</template>

<script>
import InstructionLinks from '@mixins/instruction_links'

export default {
    mixins: [InstructionLinks],

    props: {
        icon: {
            type: String,
            default: 'fas fa-info-circle'
        },
        route: {
            type: String,
            default: null
        }
    },

    computed: {
        linkToDocumentation() {
            return this.getInstructionLink(this.route ? this.route : this.$route().current(), document.documentElement.lang);
        }
    }
}
</script>
